import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import { explicitNull } from 'airbnb-prop-types';
export const pickComponentCommonProps = (props) => pick(props, ['className', 'data-testid', 'id']);
export const pickAriaProps = (props) => pickBy(props, (_, key) => key.startsWith('aria-'));
export const pickDataProps = (props) => pickBy(props, (_, key) => key.startsWith('data-'));
export const commonPropTypes = {
    /** String passed as HTML class attribute */
    className: PropTypes.string,
    /** Unique identifier for testing purposes */
    'data-testid': PropTypes.string,
    /** HTML global `id` attribute, unique in the whole document */
    id: PropTypes.string,
};
/**
 * PropType requireable equivalent to React.Ref<any>
 */
export const refPropType = () => PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
        current: PropTypes.oneOfType([
            explicitNull().isRequired,
            PropTypes.instanceOf(
            // https://stackoverflow.com/a/51127130/4773708
            (typeof Element === 'undefined' ? function () { } : Element)).isRequired,
        ]).isRequired, // Casting to allow null but not undefined
    }),
]);
//# sourceMappingURL=commonProps.js.map